<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      max-width="400"
      v-if="items.length"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          small
          color="info"
        >mdi-information</v-icon>
      </template>
        <v-card>
          <v-toolbar
            elevation="0"
          >
            <v-toolbar-title class="title">
              {{ product.description }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-list two-line dense>
              <v-subheader>Insumos requeridos</v-subheader>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
              >
                <v-list-item-avatar>
                  {{ item.quantity | numberFormat }}
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="item.product.description"></v-list-item-title>

                  <v-list-item-subtitle class="d-flex align-center"><div class="mr-2">{{ item.material }}</div><MaterialsDialog :product="item.product" :curr="getCurrency" :products="products"></MaterialsDialog></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  {{ item.cost * item.quantity | currencyFormat(getCurrency) }}
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-title>
            Costo total: {{ totalCost | currencyFormat(getCurrency) }}
          </v-card-title>
          <v-card-subtitle v-if="product.projectedCostCurrency > 0">
            Costo de insumos: {{ totalCost | currencyFormat(getCurrency) }}
          </v-card-subtitle>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MaterialsDialog',
  data () {
    return {
      dialog: false
    }
  },
  props: {
    product: Object,
    products: Array,
    priceList: {
      type: String,
      default: 'general'
    },
    curr: String
  },
  components: {
  },
  computed: {
    currency () {
      if (this.curr) return this.curr
      const price = this.product.prices?.find((price) => price.priceList === this.priceList)
      return price?.currency || 'CRC'
    },
    items () {
      const materials = []
      const steps = this.product.steps || []
      for (let i = 0; i < steps.length; i++) {
        const step = steps[i]
        const drm = step.drm || []
        materials.push(...drm)
      }
      return materials.map((mt) => {
        const product = this.productsIndexed[mt.material]
        const cost = this.getCost(product, this.getCurrency)
        return { ...mt, product, cost }
      })
    },
    productsIndexed () {
      return this.products?.reduce((acc, curr) => {
        acc[curr.commercialCode] = curr
        return acc
      }, {})
    },
    totalCost () {
      return this.getCost(this.product, this.getCurrency)
    },
    ...mapGetters([
      'getExchangeRateUSD',
      'getCurrency'
    ])
  },
  methods: {
    getCost (product, currency) {
      if (!product) console.log({ ...this.productsIndexed })
      let value = 0
      const price = product.prices?.length
        ? (product.prices.find(({ priceList }) => priceList === 'general') || product.prices[0])
        : null
      const projectedCostCurrency = product.projectedCostCurrency || 'CRC'
      const exchangeRate = projectedCostCurrency === currency ? 1
        : projectedCostCurrency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      if (product?.projectedCost) return Number(product.projectedCost * exchangeRate)
      const steps = product?.steps || []
      steps.forEach(step => {
        value += (step.drm?.reduce((acc, { material, quantity }) => {
          const materialCost = this.getCost(this.productsIndexed[material], currency)
          acc += (materialCost * quantity)
          return acc
        }, 0) || 0)
      })
      if (product?.isMaterial && price && !value) {
        const exchangeRate = price.currency === currency ? 1
          : price.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
        return Number(price.price * exchangeRate)
      }
      return value
    }
  }
}
</script>
